import React from "react";
import { SITE_URL } from "@/config/site";

// React 19 natively hoists <title>, <meta> and <link> to <head> when rendered
// anywhere in the tree — no react-helmet needed (helmet-async is not React 19
// compatible). JSON-LD is rendered in-document, which Google reads fine.
export default function SEO({ title, description, path = "", type = "website", jsonLd }) {
  const base = SITE_URL;
  const url = base + path;
  const fullTitle = title ? `${title} | VoiceOverKids` : "VoiceOverKids — Echte kinderen. Echte stemmen. Wereldwijd.";
  const desc = description || "Het gespecialiseerde internationale bureau voor professionele kinderstemmen. Vind, beluister en cast echte kinderstemacteurs in 30+ talen.";
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="nl_NL" />
      <meta name="twitter:card" content="summary_large_image" />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }} />
      ))}
    </>
  );
}
